<template>
  <v-toolbar app>
    <img src="/static/SecurytyNewLogo.png" height="60" />

    <p class="font-weight-black mTopLeft10">{{this.$store.getters.userEmail }}</p>
    <v-spacer></v-spacer>
    <v-menu>
      <v-avatar slot="activator" size="80">
      <v-btn icon :to="{name: 'HomePage'}" flat  class="white--orange bold" >
      VOLVER A INICIO
      </v-btn>      
    </v-avatar>
    </v-menu>
    <v-menu>
      <v-avatar slot="activator" size="80">
      <v-btn icon :to="{name: 'HomePage'}" flat  class="white--orange bold" >
      </v-btn>      
    </v-avatar>
    </v-menu>
  </v-toolbar>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
